<template>
  <div class="msgSet">
    <Card class="card">
      <Form ref="magForm" :model="msgData" :rules="msgRule" :label-width="130">
        <FormItem label="短信接口" prop="msg">
          <Input
            class="input"
            v-model="msgData.msg"
            v-filter-space
            placeholder="请输入短信接口"
          ></Input>
        </FormItem>
        <FormItem label="短信签名" prop="msgSignature">
          <Input
            class="input"
            v-model="msgData.msgSignature"
            v-filter-space
            placeholder="请输入短信签名"
          ></Input>
        </FormItem>
        <FormItem label="Accesskeyld" prop="Accesskeyld">
          <Input
            class="input"
            v-model="msgData.Accesskeyld"
            v-filter-space
            placeholder="请输入Accesskeyld"
          ></Input>
        </FormItem>
        <FormItem label="Accesskeysecret" prop="Accesskeysecret">
          <Input
            class="input"
            v-model="msgData.Accesskeysecret"
            v-filter-space
            placeholder="请输入Accesskeysecret"
          ></Input>
        </FormItem>
        <FormItem label="短信测试" prop="msgTest">
          <Input
            class="inputMsg"
            v-model="msgData.msgTest"
            v-filter-space
            placeholder="请输入手机号进行测试"
          ></Input>
          <Button type="primary" class="msgTest" @click="msgTest"
            >短信测试</Button
          >
        </FormItem>
        <FormItem>
          <Button type="primary" class="saveBtn" @click="saveSet">保存</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import { msgSave, msgTest, getMessage } from "@/api/msg";

export default {
  name: "MsgSet",
  data() {
    return {
      msgData: {
        msg: "",
        msgSignature: "",
        Accesskeyld: "",
        Accesskeysecret: "",
        msgTest: "",
      },
      msgRule: {
        msg: [
          {
            required: true,
            message: "请输入短信接口",
            trigger: "blur",
          },
          {
            min: 1,
            max: 256,
            trigger: "blur",
            message: "短信接口在256个字符以内",
          },
        ],
        msgSignature: [
          {
            required: true,
            message: "请输入短信签名",
            trigger: "blur",
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9\u4e00-\u9fa5]{2,12}$/,
            message:
              "请输入2-12位的中文、英文、数字，不支持符号（含空格），不支持全数字签名及首字母拼成的签名",
            trigger: "blur",
          },
        ],
        Accesskeyld: [
          {
            required: true,
            message: "请输入Accesskeyld",
            trigger: "blur",
          },
          {
            pattern: /^(?![0-9]+$)[a-zA-Z0-9]{1,64}$/,
            message: "请输入64位以内的字母或字母和数字",
            trigger: "blur",
          },
        ],
        Accesskeysecret: [
          {
            required: true,
            message: "请输入Accesskeysecret",
            trigger: "blur",
          },
          {
            pattern: /^(?![0-9]+$)[a-zA-Z0-9]{1,64}$/,
            message: "请输入64位以内的字母或字母和数字",
            trigger: "blur",
          },
        ],
        msgTest: [
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入合法的手机号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    link(path) {
      //  this.$Message.success("撤回成功");
      this.$router.push({ path: path });
    },
    // 保存短信配置
    saveSet() {
      this.$refs.magForm.validate((valid) => {
        if (valid) {
          let query = {
            interfaceConfig: this.msgData.msg,
            sign: this.msgData.msgSignature,
            accessKeyId: this.msgData.Accesskeyld,
            accessKeySecret: this.msgData.Accesskeysecret,
            phoneNumber: this.msgData.msgTest,
          };
          console.log("添加的信息为:", query);
          msgSave(query)
            .then((res) => {
              this.$Message.success("保存成功");
              console.log("res", res);
            })
            .catch((err) => {
              console.log(err, "请求接口失败");
            });
        } else {
          this.loading = false;
          console.log("请在正确填写表单信息");
        }
      });
    },
    // 短信测试
    msgTest() {
      if (!this.msgData.msgTest) {
        this.$Message.destroy();
        this.$Message.error("请输入手机号");
        return;
      }
      this.$refs.magForm.validate((valid) => {
        if (valid) {
          let query = {
            interfaceConfig: this.msgData.msg,
            sign: this.msgData.msgSignature,
            accessKeyId: this.msgData.Accesskeyld,
            accessKeySecret: this.msgData.Accesskeysecret,
          };
          console.log("添加的信息为:", this.msgData.msgTest, query);
          msgTest(this.msgData.msgTest, query)
            .then((res) => {
              if (res.data.code == "0") {
                this.$Message.success("短信发送成功");
              } else {
                this.$Message.success("短信发送失败");
              }
            })
            .catch((err) => {
              console.log(err, "请求接口失败");
            });
        } else {
          this.loading = false;
          console.log("请在正确填写表单信息");
        }
      });
    },
    getMessage() {
      getMessage().then((res) => {
        let json = res.data.data;
        this.msgData = Object.assign({}, this.msgData, {
          msg: json.interfaceConfig,
          msgSignature: json.sign,
          Accesskeyld: json.accessKeyId,
          Accesskeysecret: json.accessKeySecret,
          msgTest: json.phoneNumber,
        });
      });
    },
  },
};
</script>

<style lang="scss">
.msgSet {
  width: 100%;
  .card {
    width: 100%;
    min-height: calc(100vh - 150px);
    font-size: 14px;
    color: #2f4061;
    padding-top: 10px;
    .input {
      width: 410px;
    }
    .inputMsg {
      width: 280px;
    }
    .saveBtn,
    .msgTest {
      width: 104px;
      height: 36px;
      background: #3c8aff;
      border-radius: 18px;
    }
    .msgTest {
      margin-left: 25px;
    }
  }
}
</style>